import React, {Component} from 'react';
import {Table} from 'antd';
import {connect} from 'react-redux';
import moment from 'moment';
import {Link} from 'react-router';
import {queryPayablePendingRefundRemind} from '@api/incubator/payable';
import {setWbTabCurrent} from '@store/modules/incubator/wb_tab_current';

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataSource: {
        list: [],
        pagination: {},
      },
      statistics: 0,
    };
  }

  componentDidMount() {
    const { currentShow } = this.props;
    this.incuUuid = this.props.incuUuid;
    this.current = currentShow.billPenRePage || 1;
    this.payablePendingRefundRemind();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.incuUuid !== this.props.incuUuid) {
      this.incuUuid = nextProps.incuUuid;
      this.props.incuUuid && (this.current = 1);
      this.payablePendingRefundRemind();
    }
  }

  payablePendingRefundRemind = () => {
    if (!this.incuUuid) {
      return;
    }
    const { pageSize } = this.props;
    queryPayablePendingRefundRemind({
      incubatorUuid: this.incuUuid || '',
      start: this.current,
      limit: pageSize,
    }).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          dataSource: {
            list: res.data.list,
            pagination: {
              total: res.totalSize,
              pageSize: pageSize || 15,
              current: this.current,
            },
          },
          statistics: res.data.statistics,
        });
      }
    });
  };

  handleTableChange = (pagination, filters, sorter) => {
    this.current = pagination.current;
    this.payablePendingRefundRemind();
    const { currentShow } = this.props;
    currentShow.billPenRePage = pagination.current;
    this.props.dispatch(setWbTabCurrent(currentShow));
  };

  columns = () => {
    const { type } = this.props;
    return [
      {
        title: '账单编号',
        dataIndex: 'no',
        render: (text, record) => <Link to={`/incubator/bill/${record.uuid}/detail`}>{text}</Link>,
      },
      {
        title: '孵化器',
        dataIndex: 'incubator',
      },
      {
        title: '公司名称',
        dataIndex: 'custom',
      },
      {
        title: '收入类型',
        dataIndex: 'type',
        render: (text, record) => <span>{type[text]}</span>,
      },
      {
        title: '付款时间',
        dataIndex: 'date',
        render: (text, record) => (
          <span>{text ? moment.unix(text / 1000).format('YYYY-MM-DD') : ''}</span>
        ),
      },
      {
        title: '付款金额',
        dataIndex: 'price',
        render: (text, record) => <span>{text}</span>,
      },
      {
        title: '操作',
        dataIndex: 'done',
        render: (text, record) => <Link to={`/incubator/bill/${record.uuid}/back`}>退款</Link>,
      },
    ];
  };

  render() {
    const {
      dataSource: { list, pagination },
      statistics,
    } = this.state;
    const { total } = pagination;
    return (
      <div>
        <div className="tips">
          待退款(
          <span className="content">
            {total}笔 /{statistics}元
          </span>
          )
        </div>
        <Table
          columns={this.columns()}
          dataSource={list}
          pagination={pagination}
          onChange={this.handleTableChange}
          rowKey="uuid"
        />
      </div>
    );
  }
}

export default connect(state => ({ currentShow: state.wb_tab_current }))(Index);



// WEBPACK FOOTER //
// ./src/components/incubator/workbench/payables/TablePendingrefund.js